enum NuvemEnvioBillingType {
  PRE_PAID = "prepaid",
  POST_PAID = "postpaid",
}

export default NuvemEnvioBillingType;
